import React from "react";

interface BadgeProps {
  type: "danger" | "safe" | "warning";
  text: string;
}

const colorCode: Record<BadgeProps["type"], string> = {
  danger: "#DC4C64",
  safe: "#14A44D",
  warning: "#E4A11B",
};

export function Badge(props: BadgeProps) {
  return <span style={{ color: colorCode[props.type], fontSize: "smaller", fontStyle: "italic" }}>({props.text})</span>;
}
